import { useRef } from 'react';
import type { ComboBoxOptions } from '@interstate/components/ComboBox';
import type { InterstateOnChangeEvent } from '@interstate/components/InterstateEvents';
import type { DealTemplateInventoryType } from '@makemydeal/dr-dash-types';
import type { BuildVehicleSelects } from '../utils';

type UseComboBoxHandlersProps = {
    handleSelectChange: (vehicleSelect: BuildVehicleSelects, selected: string[] | string, options?: ComboBoxOptions) => void;
    inventoryTypes: DealTemplateInventoryType[];
};
const DEBOUNCE_DELAY = 100;

export const useComboBoxHandlers = ({ handleSelectChange }: UseComboBoxHandlersProps) => {
    const lastChangeTimeRef = useRef<number>(0);

    const createAutoSelectAllOnBlur = (vehicleSelect: BuildVehicleSelects, options: ComboBoxOptions) => {
        return (event: InterstateOnChangeEvent<ComboBoxOptions>) => {
            const now = Date.now();
            const timeSinceLastChange = now - lastChangeTimeRef.current;

            if (!event.target.value.length && timeSinceLastChange > DEBOUNCE_DELAY) {
                handleSelectChange(vehicleSelect, 'All', options);
            }
        };
    };

    const createMultiSelectChange = (vehicleSelect: BuildVehicleSelects, options: ComboBoxOptions) => {
        return (event: InterstateOnChangeEvent<ComboBoxOptions>) => {
            lastChangeTimeRef.current = Date.now();

            const selected = event.target.value;
            handleSelectChange(
                vehicleSelect,
                selected.map((opt) => opt.value),
                options
            );
        };
    };

    return {
        createAutoSelectAllOnBlur,
        createMultiSelectChange
    };
};
